<template>
    <d-container fluid class="main-content-container px-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Your Iv.js tag</h3>
            </d-col>
        </d-row>
        <d-row>
            <d-col lg="4" class="mx-auto mt-4">
                <d-card class="card-small mb-4 pt-3">
                    <!-- Card Header -->
                    <d-card-header class="border-bottom text-center">
                        <!-- User Avatar -->
                        <div class="mb-3 mx-auto">
                            <i class="material-icons code">code</i>
                        </div>
                        <!-- User Name -->
                        <h4 class="mb-0">Iv.js - Tag</h4>
                    </d-card-header>
                    <d-list-group flush>
                        <!-- User Meta -->
                        <d-list-group-item>
                            <d-form>
                                <d-form-row>
                                    <d-col class="mb-3">
                                        Install the Iv.js tag to your website In order to push your affiliate transactions to Google Analytics, Google Ads and Microsoft Advertising you need to install the iv.js tag to every page of your website. The tag will deliver unique sub-id's and anonymize visitor profile data.
                                    </d-col>
                                </d-form-row>
                                <d-form-row>
                                </d-form-row>
                            </d-form>
                        </d-list-group-item>
                    </d-list-group>
                    <d-card-footer class="border-top d-flex justify-content-end">
                    </d-card-footer>
                </d-card>
            </d-col>
            <d-col lg="8" class="mx-auto mt-4">
                <d-card class="card-small edit-user-details mb-4">
                    <d-card-header class="border-bottom">
                        <h6 class="m-0">Iv.js tag</h6>
                    </d-card-header>
                    <d-card-body class="p-0">
                        <d-form class="py-4">
                            <d-form-row class="mx-4">
                                <d-col md="12" class="mb-3">
                                    <d-form-text tag="p" class="text-muted m-0">Insert this code in the header of your website in order to load the tag on every page</d-form-text>
                                </d-col>
                                <d-col cols="9" class="mb-3 script-tag">
                                    <d-form-text tag="h6" class="m-0">
                                        {{ tag }}
                                    </d-form-text>
                                </d-col>
                                <d-col class="mb-3">
                                    <button type="button" v-clipboard="tag" @click="showSuccess" class="btn btn-success btn-sm">Copy to Clipboard</button>
                                </d-col>
                            </d-form-row>
                        </d-form>
                    </d-card-body>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
    import notification from '@/mixins/notification';

    export default {
        mixins: [notification],

        data() {
            return {
                tag: '<script type="text/javascript" src="https://ivanhoe.io/iv.js">' + '<' + '/script>',
            };
        },

        methods: {
            showSuccess() {
                this.showNotification('success', 'Alert', 'Copied to clipboard!')
            }
        }
    };
</script>
